import { graphql } from "@cappelendamm/crystallize-types/core/gql";
export const fetchSubscriptionSkusByProductId = async (itemId, { client }) => {
    const data = await client.core.request(graphql(`
      query SubscriptionProductByItemId($itemId: ID!) {
        item(id: $itemId, language: "no-nb") {
          ... on Product {
            __typename
            name
            variants {
              sku
            }
          }
        }
      }
    `), {
        itemId,
    });
    if (!data || !data.item?.__typename || data.item.__typename !== "Product") {
        throw new Error(`Could not find subscription item for itemId: ${itemId}`);
    }
    return data.item;
};
